import { MobileWatchList } from '../../components/WatchList/MobileWatchList';
import type { LayoutComponentScreen } from '../types';
import {
  BalancesScreen,
  CreditScreen,
  OrderCardsScreen,
  RFQFormScreen,
  TradesScreen,
  TransfersScreen,
  WatchListScreen,
} from './screenLibrary';

export const simpleRFQMobileScreens: LayoutComponentScreen[] = [
  { ...WatchListScreen, component: <MobileWatchList securityRoute="/trade" /> },
  OrderCardsScreen,
  RFQFormScreen,
  BalancesScreen,
  TradesScreen,
  CreditScreen,
  TransfersScreen,
];
